import { HeroSection } from "@/components/HeroSection";
import { ProblemSection } from "@/components/ProblemSection";
import { SolutionSection } from "@/components/SolutionSection";
import { CTASection } from "@/components/CTASection";
import { Footer } from "@/components/Footer";
import { ThemeToggle } from "@/components/ThemeToggle";
import { BugShowcase } from "@/components/BugShowcase";
import { BugFlowAnimation } from "@/components/BugFlowAnimation";

const Index = () => {
  return (
    <main className="min-h-screen [&>section+section]:border-t [&>section+section]:border-border/50 dark:[&>section+section]:border-transparent">
      <ThemeToggle />
      <HeroSection />

      {/* How Healion Works Section */}
      <section className="py-16 sm:py-24 px-4 bg-muted/30">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-foreground">
              How <span className="text-accent">Healion</span> Works
            </h2>
            <p className="text-muted-foreground text-lg">
              From bug detection to automated fix in minutes
            </p>
          </div>
          <BugFlowAnimation />
        </div>
      </section>

      {/* Bug Fix Showcase Section */}
      <section className="py-16 sm:py-24 px-4 bg-background">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold mb-4 text-foreground">
              See Healion in <span className="text-accent">Action</span>
            </h2>
            <p className="text-muted-foreground text-lg">
              Watch how Healion identifies bugs, finds root causes, and generates production-ready fixes
            </p>
          </div>
          <BugShowcase />
        </div>
      </section>

      <ProblemSection />
      <SolutionSection />
      <CTASection />
      <Footer />
    </main>
  );
};

export default Index;
